import { Component } from '@angular/core';

@Component({
    selector: 'assigned-chats',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AssignedChatsComponent {}
